import notificationDot from "@assets/web-v3-images/icons/notification-dot.png";

const NotificationDotIcon = ({ width = 24, height = 24, className }) => (
  <img src={notificationDot} alt="Notification Dot" width={width} height={height} className={className} />
);

export default NotificationDotIcon;
